/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { ApiError } from 'api/core/ApiError';
import type { ApiRequestOptions } from 'api/core/ApiRequestOptions';
import { CancelablePromise } from 'api/core/CancelablePromise';
import type { OpenAPIConfig } from 'api/core/OpenAPI';
import { clientWithAuth, clientWithoutAuth } from 'dashboard409a/services/base';
import { getStoredAccessToken } from 'pages/Auth/utils/authStorage';
import { AxiosResponse } from 'axios';

export const isDefined = <T>(value: T | null | undefined): value is Exclude<T, null | undefined> => {
  return value !== undefined && value !== null;
};

export const isString = (value: any): value is string => {
  return typeof value === 'string';
};

export const isStringWithValue = (value: any): value is string => {
  return isString(value) && value !== '';
};

export const isBlob = (value: any): value is Blob => {
  return (
    typeof value === 'object' &&
    typeof value.type === 'string' &&
    typeof value.stream === 'function' &&
    typeof value.arrayBuffer === 'function' &&
    typeof value.constructor === 'function' &&
    typeof value.constructor.name === 'string' &&
    /^(Blob|File)$/.test(value.constructor.name) &&
    /^(Blob|File)$/.test(value[Symbol.toStringTag])
  );
};

export const isFormData = (value: any): value is FormData => {
  return value instanceof FormData;
};

export const base64 = (str: string): string => {
  try {
    return btoa(str);
  } catch (err) {
    // @ts-ignore
    return Buffer.from(str).toString('base64');
  }
};

export const getQueryString = (params: Record<string, any>): string => {
  const qs: string[] = [];

  const append = (key: string, value: any) => {
    qs.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
  };

  const process = (key: string, value: any) => {
    if (isDefined(value)) {
      if (Array.isArray(value)) {
        value.forEach(v => {
          process(key, v);
        });
      } else if (typeof value === 'object') {
        Object.entries(value).forEach(([k, v]) => {
          process(`${key}[${k}]`, v);
        });
      } else {
        append(key, value);
      }
    }
  };

  Object.entries(params).forEach(([key, value]) => {
    process(key, value);
  });

  if (qs.length > 0) {
    return `?${qs.join('&')}`;
  }

  return '';
};

const getUrl = (config: OpenAPIConfig, options: ApiRequestOptions): string => {
  const encoder = config.ENCODE_PATH ?? encodeURI;

  const path = options.url
    .replace('{api-version}', config.VERSION)
    .replace(/{([^{}]+)}/g, (substring: string, group: string) => {
      if (options.path?.hasOwnProperty(group)) {
        return encoder(String(options.path[group]));
      }
      return substring;
    });

  const url = `${path}`;
  if (options.query) {
    return `${url}${getQueryString(options.query)}`;
  }
  return url;
};

type Resolver<T> = (options: ApiRequestOptions) => Promise<T>;

export const resolve = async <T>(options: ApiRequestOptions, resolver?: T | Resolver<T>): Promise<T | undefined> => {
  if (typeof resolver === 'function') {
    return (resolver as Resolver<T>)(options);
  }
  return resolver;
};

export const getRequestBody = (options: ApiRequestOptions): any => {
  if (options.body !== undefined) {
    if (options.mediaType?.includes('/json')) {
      return JSON.stringify(options.body);
    } else if (isString(options.body) || isBlob(options.body) || isFormData(options.body)) {
      return options.body;
    } else {
      return JSON.stringify(options.body);
    }
  }
  return undefined;
};

const PUBLIC_AUTH_REQUESTS = new Set([
  '/auth/jwt/create',
  '/auth/jwt/refresh',
  '/auth/jwt/verify',
  '/auth/users/activation/',
  '/auth/users/resend_activation/',
  '/auth/users/reset_password_confirm/',
  '/api/oauth2/social/',
  '/api/sso/discover',
  '/api/sso/exchange',
  '/api/sso/login',
  '/api/sso/slug-discovery',
]);

const shouldUsePublicAuthClient = (options: ApiRequestOptions) => {
  // Anonymous forgot-password must stay public. In-app profile/admin resets should
  // send the JWT so the backend can skip Turnstile for authenticated callers.
  if (options.url === '/auth/users/reset_password/') {
    return !getStoredAccessToken();
  }

  if (PUBLIC_AUTH_REQUESTS.has(options.url)) {
    return true;
  }

  // Account creation is the only anonymous request on /auth/users/; other methods there can stay on the auth client.
  if (options.method === 'POST' && options.url === '/auth/users/') {
    return true;
  }

  return options.method === 'POST' && options.url.startsWith('/api/sso/acs/');
};

/**
 * Request method
 * @param config The OpenAPI configuration object
 * @param options The request options from the service
 * @returns CancelablePromise<T>
 * @throws ApiError
 */

export const request = <T>(config: OpenAPIConfig, options: ApiRequestOptions): CancelablePromise<T> => {
  return new CancelablePromise((resolve, reject, onCancel) => {
    try {
      const url = getUrl(config, options);
      const body = getRequestBody(options);
      const client = shouldUsePublicAuthClient(options) ? clientWithoutAuth : clientWithAuth;
      const abortController = new AbortController();

      onCancel(() => abortController.abort());

      if (!onCancel.isCancelled) {
        client
          .request<T, AxiosResponse<PromiseLike<T>>>({
            url,
            method: options.method,
            data: body,
            // The shared Axios client defaults to application/json. Removing
            // that default lets Axios/browser add the multipart boundary.
            headers: isFormData(body) ? { 'Content-Type': undefined } : undefined,
            signal: abortController.signal,
            withCredentials: config.WITH_CREDENTIALS,
          })
          .then(data => {
            resolve(data.data);
          })
          .catch(error => reject(error));
      } else {
        reject(new Error('Request cancelled'));
      }
    } catch (error) {
      reject(error);
    }
  });
};
